export default __webpack_public_path__ + "static/media/forklift.0525d710.png";